import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { authApi } from '@/api/auth.api';
import { formatApiMessage } from '@/api/client';

export function VerifyEmailBanner() {
  const { t } = useTranslation();
  const mutation = useMutation({
    mutationFn: authApi.resendVerification,
    onSuccess: (data) => {
      if (data.sent) toast.success(t('auth.verify_email_sent'));
      else toast.info(t('auth.already_verified'));
    },
    onError: (err) => toast.error(formatApiMessage(err)),
  });

  return (
    <div className="rounded-md border border-amber-200 bg-warning-bg px-4 py-3 flex items-center justify-between gap-4">
      <div className="text-sm text-warning">
        <strong>{t('auth.verify_banner_title')}</strong>{' '}
        {t('auth.verify_banner_text')}
      </div>
      <button
        onClick={() => mutation.mutate()}
        disabled={mutation.isPending}
        className="btn btn-secondary shrink-0"
      >
        {mutation.isPending ? t('auth.sending') : t('auth.resend')}
      </button>
    </div>
  );
}
